import { loginSuccess, apiError, logoutUserSuccess, resetLoginFlag } from "./reducer";
import { toast } from 'react-toastify'
import { NavigateFunction, } from "react-router-dom";

export interface LoginUserResults {
    email: string,
    password: string,
}


const MORNING_GREETING = "Good Morning";
const AFTER_NOON_GREETING = "Good Afternoon";
const EVENING_GREETING = "Good Evening";
const LATE_EVENING_GREETING = "Good Late Night";
const EARLY_MORNING_GREETING = "Good Early Morning";

const getGreetingMessage = () => {
    const now = new Date();
    const hour = now.getHours(); // 0–23

    // 5am - 12pm
    if (hour >= 5 && hour < 12) {
        return MORNING_GREETING;
    }

    // 12pm - 5pm
    if (hour >= 12 && hour < 17) {
        return AFTER_NOON_GREETING;
    }

    // 5pm - 10pm
    if (hour >= 17 && hour < 22) {
        return EVENING_GREETING;
    }

    // 10pm - 2am
    if (hour >= 22 || hour < 2) {
        return LATE_EVENING_GREETING;
    }

    // 2am – 5am
    return EARLY_MORNING_GREETING;
};



export const loginuser = (user: LoginUserResults, history: NavigateFunction) => async (dispatch: any) => {
    try {   
        const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user),
            credentials: 'include'
        })

        if (!res.ok) {
            const json = await res.json()
            json.message && toast(json.message, { type: 'error' }) && dispatch(apiError(json.message))
            return false;
        }


        toast.success(getGreetingMessage())
        dispatch(loginSuccess())
        history("/dashboard")
        return true;
    } catch (err: any) {
        dispatch(apiError("Error authenticating."));
        toast("Error authenticating please try again", { type: 'error' })
        return false;
    }
}

export const logoutUser = () => async (dispatch: any) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
            credentials: 'include',
            method: 'POST'
        })


        if (res.ok) {
            toast.success("User logged out")
            dispatch(logoutUserSuccess(true));
            return true;
        } else {
            toast.error("Error logging out.");
            return false
        }
    } catch (err: any) {
        dispatch(apiError("Error logging out user."));
        toast.error("Error logging out.");
        return false
    }
};

export const resetLoginMsgFlag = () => {
    try {
        const response = resetLoginFlag();
        return response;
    } catch (error) {
        return error;
    }
};



